import { render, staticRenderFns } from "./profile-card-settings.vue?vue&type=template&id=2c7d6c14"
import script from "./profile-card-settings.vue?vue&type=script&lang=js"
export * from "./profile-card-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports